import React from "react"
import { Box } from "@mui/material"

import { AppRetailerBlock } from "@components/DataBlocks/index"
import AppListDialog, { listItemSx } from "@components/DataBlocks/ListDialog"
import { sitesModalData } from "@signals"
import ModalCountriesSelector from "./Countries"
import useSiteModalFilter from "./@hooks"
import ModalSitesSelector from "./Sites"


export default function AppSitesModal({ ...props }) {

	const {
		filteredList,
		filteredSites,
		onChangeSite,
		onChangeCountry,
		countriesOptions,
		applyFilters
	} = useSiteModalFilter()

	return <AppListDialog
		open={!!sitesModalData.value?.length}
		onClose={() => sitesModalData.value = []}
		icon="globe"
		title="Sites"
		noun="sites"
		total={sitesModalData.value?.length || 0}
		shown={filteredList.length}
		containerProps={props.containerProps}
		filters={<>
			<ModalSitesSelector
				applyFilters={applyFilters}
				filteredSites={filteredSites}
				onChangeSite={onChangeSite}
			/>
			<ModalCountriesSelector
				applyFilters={applyFilters}
				countriesOptions={countriesOptions}
				onChangeCountry={onChangeCountry}
			/>
		</>}
	>
		{filteredList.map(({ name, market }, idx) => (
			<Box key={`${name}-${idx}`} sx={listItemSx}>
				<AppRetailerBlock
					retailer={name}
					country={market}
					{...props.sitesProps}
				/>
			</Box>
		))}
	</AppListDialog>
}
